import { create } from 'zustand';

import events from '../../utils/moengage/events.json';

interface JsonCommonType {
  [key: string]: any;
}

interface MoengageStore extends JsonCommonType {
  mobileNumber: string | undefined;
  invoiceBalance: number;
  nonInvoiceBalance: string;
  setMobileNumber: (mobileNumber: string) => void;
  setDgWalletInvoiceBalance: (invoiceBalance: number) => void;
  setDgWalletNonInvoiceBalance: (nonInvoiceBalance: string) => void;
}

const useMoengageStore = create<MoengageStore>()((set) => ({
  mobileNumber: undefined,
  nonInvoiceBalance: '0',
  invoiceBalance: 0,
  ...events,
  setMobileNumber: (mobileNumber) => set((_state) => ({ mobileNumber })),
  setDgWalletInvoiceBalance: (invoiceBalance) =>
    set((_state) => ({ invoiceBalance })),
  setDgWalletNonInvoiceBalance: (nonInvoiceBalance) =>
    set((_state) => ({ nonInvoiceBalance })),
}));

export default useMoengageStore;
